enum DistressCategory {
  Point = "Point",
  Longitudinal = "Longitudinal",
  Transversal = "Transversal",
  Area = "Area",
  Span = "Span",
}

export default DistressCategory;
